module.exports = __webpack_public_path__ + "static/img/title.e8f95109.png";